import React from 'react';
import { ButtonTemplateProps } from '..';
import { TranslationKey } from '../../../../types/translation/TranslationKey';
import { t } from '../../../../types/translation/Translator';
import { Button, ButtonVariant } from '../Button';

interface CancelButtonProps extends ButtonTemplateProps {}

export default function CancelButton(props: CancelButtonProps) {
  return <Button {...props} text={t(TranslationKey.cancel).singular.upper} variant={ButtonVariant.link} />;
}
